/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-19 18:13:35
 * @LastEditTime: 2022-01-21 21:27:44
 * @LastEditors: zhao - 🍉
 * @Description: 微信客服
 * @FilePath: /zhzj-admin/src/page/CustomerServices/WeChatServices/index.jsx
 */

import React from 'react'
import { Link } from 'react-router-dom';
import AuthButton from '../../../components/AuthButton/AuthButton';
import PageWrap from '../../../components/PageWrap';
import TableHelper from "../../../components/TableHelper";
import { fetchWechatServicesSalesList } from '../../../services/wechatServices';
import { formatTime } from '../../../utils';

const WeChatServices = (props) => {
    const columns = [
        { title: '顾问头像', dataIndex: 'guide_headimgurl', render: text => {
            if (!text) return null
            return <img src={text} style={{width:35, height: 35}} alt="" />
        }  },
        { title: '顾问昵称', dataIndex: 'guide_nickname'},
        { title: '顾问账号', dataIndex: 'guide_account', },
        { title: '平台用户姓名', dataIndex: 'employeeName', },
        { title: '平台用户手机号码', dataIndex: 'employeePhone', },
        { title: '创建时间', dataIndex: 'create_time', render: formatTime},
        { title: '操作', dataIndex: 'actions', render: (text, record) => {
            return <AuthButton authkey="n-1-1">
                <Link to={'/admin/customer/customer-list?guideAccount=' + record.guide_account}><a >微信客户列表</a></Link>
            </AuthButton>
        } }
        
    ]
    return (
        <PageWrap>
            <TableHelper request={fetchWechatServicesSalesList} columns={columns} />
        </PageWrap>
    )
}

export default WeChatServices 



// WEBPACK FOOTER //
// ./src/page/CustomerServices/WeChatServices/index.jsx